import axios from "axios";
import type { App } from "vue";

let config: object = {};
const { VITE_PUBLIC_PATH, VITE_MODE } = import.meta.env;

const setConfig = (cfg?: unknown) => {
  config = Object.assign(config, cfg);
};

const getConfig = (key?: string): PlatformConfigs => {
  if (typeof key === "string") {
    const platform = sessionStorage.getItem("platform-config") || "{}";
    let data = { ...config, ...JSON.parse(platform) };
    if (data) {
      //20250512 hwei BaseURLFile 由up_ur参数l+BaseURLMinioContainer参数拼接
      if (key === "BaseURLFile") {
        let key_data = data["up_url"] + data["BaseURLMinioContainer"] + "/";
        return key_data;
      }
      const arr = key.split(".");
      if (arr && arr.length) {
        arr.forEach(v => {
          if (data && typeof data[v] !== "undefined") {
            data = data[v];
          } else {
            data = null;
          }
        });
        return data;
      }
    }
  }
  return config;
};

/** 获取项目动态全局配置 */
export const getPlatformConfig = async (app: App): Promise<undefined> => {
  app.config.globalProperties.$config = getConfig();
  return axios({
    method: "get",
    url: `${VITE_PUBLIC_PATH}platform-config.json`
  })
    .then(({ data: config }) => {
      let $config = app.config.globalProperties.$config;
      // 自动注入系统配置
      if (app && $config && typeof config === "object") {
        if (config?.MappingUrl && config?.MappingUrl[location.host]) {
          config = Object.assign(config, config?.MappingUrl[location.host]);
        }
        $config = Object.assign($config, config);

        app.config.globalProperties.$config = $config;
        sessionStorage.setItem("platform-config", JSON.stringify($config));
        // 设置全局配置
        setConfig($config);
      }
      return $config;
    })
    .catch(() => {
      throw "请在public文件夹下添加platform-config.json配置文件";
    });
};
/** 获取项目动态全局配置 */
export const getServeRemote = async () => {
  return axios({
    method: "get",
    url: `${VITE_PUBLIC_PATH}serve_remote.json`
  })
    .then(({ data }) => {
      return data;
    })
    .catch(() => {
      throw "请在public文件夹下添加serve_remote.json可做服务文件";
    });
};

/** 本地响应式存储的命名空间 */
const responsiveStorageNameSpace = () => getConfig().ResponsiveStorageNameSpace;

export { getConfig, setConfig, responsiveStorageNameSpace };
